<div class="flex items-center justify-center min-h-screen">
  <div class="text-center">
    <div class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
    <p class="mt-4 text-gray-400">Loading...</p>
  </div>
</div>
